import { ActionResponse } from 'src/app/models/action-response';
import { AddBillingitemTopackageDueDates } from 'src/app/shared-components/allocation-wizard-modal-dialogs/add-billingitems-topackage-wizard/init-step/addbillingitems-due-date-info';
import { AddBillingitemTopackageInitStep } from 'src/app/shared-components/allocation-wizard-modal-dialogs/add-billingitems-topackage-wizard/init-step/init-step';

export interface State {
  initStep: AddBillingitemTopackageInitStep;
  dueDatesStep: AddBillingitemTopackageDueDates;
  response: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  initStep: null,
  dueDatesStep: { activationDate: null, deactivationDate: null },
  response: null,
  errorMessage: null,
};
